import { Navigate, Route, Routes } from "react-router-dom";
import React from "react";
import Dam from "./pages/Dam/Dam";
import Home from "./pages/Home/Home";
import Layout from "../layouts/Layout";
import Media from "./pages/MediaDetail/Media";
import MediaChapter from "./pages/MediaChapter/MediaChapter";
import MediaChapters from "./pages/MediaChapters/MediaChapters";
import MediaDetails from "./pages/MediaDetail/MediaDetails";
import MediaList from "../routes/pages/MediaList/MediaList";
import MediaPublish from "./pages/MediaPublish/MediaPublish";
import MediaSecurity from "./pages/MediaSecurity/MediaSecurity";
import MediaSubtitle from "./pages/MediaSubtitle/MediaSubtitle";
import MediaTranscript from "./pages/MediaTranscript/MediaTranscript";
import MediaLogs from "../routes/pages/MediaLogs/MediaLogs";
import UserList from "./pages/User/UserList";
import UserDetails from "@/components/UserPages/UserDetails";
import SocialList from "./pages/Social/SocialList";
import { Empty, PageNotFound } from "../components";
import BusinessList from "./pages/Business/Business";
import ProductList from "./pages/Product/Product";
import AgencyList from "./pages/Agencies/Agency";
import OrgList from "./pages/Organizations/Organisation";
import Setting from "./pages/Setting/Setting";

import Discover from "./pages/Discover/Discover";

import MetaDefault from "./pages/MetaDefault/MetaDefault";

import MetaManagement from "./pages/MetaManagement/MetaManagement";
import MetaPresets from "./pages/MetaPresets/MetaPresets";
import PreviewTest from "./pages/PreviewTest/PreviewTest";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      {/* <Route path="/" index element={<Layout />} /> */}
      {/* <Route path="/setting" element={<Setting />} /> */}
      <Route path="/preview-test" element={<PreviewTest />} />

      {/* Private Routes with Layout wrapper */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/analytics" element={<Empty msg="Work In Progress" />} />
        <Route path="/live" element={<Empty msg="Work In Progress" />} />
        <Route path="/users" element={<UserList />} />
        <Route path="/users/add" element={<UserList />} />
        <Route path="/users/:userId" element={<UserList />} />
        <Route path="/user/:userId" element={<UserDetails />} />
        <Route path="/socialconnect" element={<SocialList />} />
        {/* <Route path="/media/:tabName" element={<MediaList />} /> */}
        <Route path="/media/:slikeId" element={<Media />}>
          <Route path="" element={<MediaDetails />} />
          <Route path="details" element={<MediaDetails />} />
          <Route path="chapter" element={<MediaChapter />} />
          <Route path="chapters" element={<MediaChapters />} />
          <Route path="clips" element={<MediaChapter />} />
          <Route path="chapter" element={<Navigate to="../clips" replace />} />
          <Route path="subtitle" element={<MediaSubtitle />} />
          <Route path="transcript" element={<MediaTranscript />} />
          <Route path="logs" element={<MediaLogs />} />
          <Route path="social-publish" element={<MediaPublish />} />
          <Route path="security" element={<MediaSecurity />} />
        </Route>

        <Route path="/admin">
          <Route path="" element={<BusinessList />} />
          <Route path="business" element={<BusinessList />} />
          <Route path="product" element={<ProductList />} />
          <Route path="organization" element={<OrgList />} />
          <Route path="agencies" element={<AgencyList />} />
        </Route>
        <Route path="/meta-managements">
          <Route path="" element={<Empty msg="Work In Progress" />} />
          <Route path="language" element={<MetaManagement />} />
          <Route path="category" element={<MetaManagement />} />
          <Route path="cast" element={<MetaManagement />} />
          <Route path="genre" element={<MetaManagement />} />
          <Route path="tags" element={<MetaManagement />} />
          <Route path="manage-listing" element={<MetaDefault />} />
        </Route>
        <Route path="/configuration">
          <Route path="" element={<Empty msg="Work In Progress" />} />
          <Route path="workflows" element={<Empty msg="Work In Progress" />} />
          <Route
            path="archival-policy"
            element={<Empty msg="Work In Progress" />}
          />
          <Route path="api-config" element={<Empty msg="Work In Progress" />} />
          <Route path="buckets" element={<Empty msg="Work In Progress" />} />
          {/* <Route path="presets" element={<Presets />} /> */}
          <Route path="meta-presets" element={<MetaPresets />} />
          <Route path="Feeds" element={<Empty msg="Work In Progress" />} />
        </Route>
        <Route path="/meta-presets">
          {["meta", "social", "processing", "branding", "transcoding"].map(
            (path) => (
              <Route key={path} path={path} element={<MetaPresets />} />
            )
          )}
        </Route>

        <Route path="/media">
          <Route index element={<MediaList />} />
          {["video", "audio", "shorts", "premiere"].map((path) => (
            <Route key={path} path={path} element={<MediaList />} />
          ))}
        </Route>
        <Route path="/drive">
          <Route path="video" element={<MediaList />} />
          <Route path="shorts" element={<MediaList />} />
        </Route>
        <Route path="/discover">
          {["wired", "inhouse"].map((path) => (
            <Route key={path} path={path} element={<Discover />} />
          ))}
        </Route>

        <Route path="/dam" element={<Dam />} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;
